import { US_COUNTRY_ISO2 } from '@/lib/constants/geography';
import type { CityScope } from '@/lib/types/geography.types';

/** The HQ cascade's shape for one country/state selection, derived once. */
export interface HqCascade {
  /** State/Province is only asked for US headquarters (UX sheet r105). */
  showState: boolean;
  /** What City searches within; absent while City cannot be searched yet. */
  cityScope?: CityScope;
  /**
   * State to keep alongside a picked city: the US state, or none for a non-US
   * city so the Backend derives it from the city instead of a stale value.
   */
  cityStateId?: number;
}

/**
 * Resolves Country > State > City (US) versus Country > City (non-US).
 * An unresolved country (list still loading) enables nothing, so a US country
 * never briefly searches cities country-wide.
 */
export function resolveHqCascade(
  country: { id: number; iso2: string } | undefined,
  stateId: number | undefined,
): HqCascade {
  if (!country) return { showState: false };
  if (country.iso2 !== US_COUNTRY_ISO2) {
    return { showState: false, cityScope: { kind: 'country', id: country.id } };
  }
  return {
    showState: true,
    cityScope: stateId === undefined ? undefined : { kind: 'state', id: stateId },
    cityStateId: stateId,
  };
}
